import React from 'react';
import { AiOutlineSearch } from 'react-icons/ai';
import { Popconfirm, Input, Button, Pagination, Row, Col } from 'antd';
import { useDispatch } from 'react-redux';
import { useI18n } from 'hooks/useI18n';
import { SERVER_IP } from 'assets/Config';
import TableComponent from 'components/table-component';
import { deleteApi } from 'redux/sagas/deleteApiSaga';
import AddPersonalTraining from 'pages/personal-training/add-personal-training';
import { ReloadOutlined } from '@ant-design/icons';
import { getRowColor } from 'helpers';

const PersonalTrainingListPresentational = ({
	filteredData,
	column,
	tableLoading,
	rowSelection,
	selectedRowKeys,
	handleAddPersonalTraining,
	currentPage,
	pageSize,
	initialPageSizeOptions,
	initialPageSize,
	handleTableChange,
	setSearchKey,
	getStartingValue,
	getEndingValue,
	personalTrainingAddModal,
	setPersonalTrainingAddModal,
	refreshList,
	editPersonalTraining,
	handleClose,
}) => {
	const dispatch = useDispatch();
	const { t } = useI18n();
	return (
		<>
			<Row className="personal_list_page">
				<Col span={24} style={{ paddingBottom: 20 }}>
					<TableComponent
						loading={tableLoading}
						className="custom-table"
						style={{ width: '100%' }}
						columns={column}
						bordered
						rowKey={(record) => record.id}
						rowClassName={(record) => {
							return getRowColor(record?.nextBillDate);
						}}
						dataSource={filteredData}
						rowSelection={rowSelection}
						title={() => (
							<Row style={{ justifyContent: 'space-between' }}>
								<Col span={8}>
									<Row gutter={[10, 10]}>
										<Col xl={24}>
											<Row gutter={[10, 10]} align="middle">
												<Col>
													<Input
														placeholder={t('personal_training.search_placeholder')}
														suffix={<AiOutlineSearch />}
														style={{ height: '30px' }}
														onChange={({ target: { value } }) => setSearchKey(value)}
													/>
												</Col>
												{selectedRowKeys?.length === 1 ? (
													<Col>
														<Popconfirm
															title={t('personal_training.delete_confirm')}
															okText={t('common.delete')}
															cancelText={t('common.no')}
															onConfirm={() => {
																let url = `${SERVER_IP}api/personalTraining/${selectedRowKeys?.[0]}`;
																dispatch(deleteApi('DELETE_PT', url));
															}}>
															<div style={{ textDecoration: 'underline', color: 'red', cursor: 'pointer' }}>{t('common.delete')}</div>
														</Popconfirm>
													</Col>
												) : null}
											</Row>
										</Col>
									</Row>
								</Col>
								<Col>
									<Button
										type="primary"
										icon={<ReloadOutlined />}
										loading={tableLoading}
										onClick={() => refreshList?.()}
										style={{ marginRight: 10 }}
									/>
									<Button
										// icon={<PlusOutlined />}
										type="primary"
										// style={{ height: '30px', width: '100%' }}
										onClick={handleAddPersonalTraining}>
										{t('personal_training.create_pt')}
									</Button>
								</Col>
							</Row>
						)}
						pagination={{
							current: currentPage,
							pageSize: pageSize,
							position: ['none', 'none'],
						}}
						footer={() => (
							<Row justify="space-between">
								<Col span={12}>
									{!!filteredData?.length && t('personal_training.footer.showing_range', { 
										start: getStartingValue(), 
										end: getEndingValue(), 
										total: filteredData?.length 
									})}
								</Col>
								<Col span={12}>
									<div style={{ textAlign: 'right' }}>
										<Pagination
											pageSizeOptions={initialPageSizeOptions}
											defaultPageSize={initialPageSize}
											showSizeChanger={true}
											total={filteredData?.length}
											onChange={handleTableChange}
											responsive
										/>
									</div>
								</Col>
							</Row>
						)}
					/>
				</Col>
			</Row>
			<AddPersonalTraining {...{ personalTrainingAddModal, setPersonalTrainingAddModal, refreshList, editPersonalTraining, handleClose }} />
		</>
	);
};

export default PersonalTrainingListPresentational;
